<template>
  <div :class="jel_getClassObject(content)">
    <b-form-checkbox v-model="recevoirCommunication" :name="content.libRecevoirCommunication">
      <span class="font-weight-normal" v-html="content.libRecevoirCommunication" />
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'FormulaireRecevoirCommunication',
  props: { content: { type: Object, required: true } },
  computed: {
    recevoirCommunication: {
      get() {
        return this.$store.state.compte.recevoirCommunication;
      },
      set(value) {
        this.$store.commit('compte/SET_RECEVOIR_COMMUNICATION', value);
      },
    },
  },
};
</script>
